import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axios";

const AdminFacultades = () => {
  const navigate = useNavigate();

  const [alerta, setAlerta] = useState({
    mostrar: false,
    mensaje: "",
    tipo: "success",
  });

  const [facultades, setFacultades] = useState([]);
  const [loading, setLoading] = useState(true);

  const [mostrarModal, setMostrarModal] = useState(false);
  const [mostrarEliminar, setMostrarEliminar] = useState(false);
const [facultadEliminar, setFacultadEliminar] = useState(null);
  const [editando, setEditando] = useState(false);
  const [facultadId, setFacultadId] = useState(null);

  const [nuevaFacultad, setNuevaFacultad] = useState({
    nombre: "",
    valor_nucleo: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNuevaFacultad((prev) => ({ ...prev, [name]: value }));
  };

  const mostrarAlerta = (mensaje, tipo = "success") => {
    setAlerta({
      mostrar: true,
      mensaje,
      tipo,
    });

    setTimeout(() => {
      setAlerta({ mostrar: false, mensaje: "", tipo: "success" });
    }, 3000);
  };

  // Cargar facultades
  const cargarFacultades = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/facultades");
      setFacultades(response.data.facultades || []);
    } catch (error) {
      console.error("Error al cargar facultades:", error);
      mostrarAlerta("Error al cargar las facultades", "danger");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarFacultades();
  }, []);

  // Guardar (crear o editar)
  const guardarFacultad = async () => {
    if (!nuevaFacultad.nombre.trim()) {
      mostrarAlerta("El nombre de la facultad es obligatorio", "danger");
      return;
    }

    const url = editando ? `/facultades/${facultadId}` : "/crearfacultad";
    const method = editando ? "put" : "post";

    try {
      await axios[method](url, {
        nombre: nuevaFacultad.nombre.trim(),
        valor_nucleo: parseFloat(nuevaFacultad.valor_nucleo) || 0,
      });

      setMostrarModal(false);
      setEditando(false);
      setFacultadId(null);
      setNuevaFacultad({ nombre: "", valor_nucleo: "" });
      
      mostrarAlerta(
        editando ? "Facultad actualizada correctamente" : "Facultad creada correctamente"
      );
      
      cargarFacultades();
    } catch (error) {
      console.error("Error al guardar facultad:", error);
      mostrarAlerta(
        error.response?.data?.message || "Error al guardar la facultad",
        "danger"
      );
    }
  };

  // Preparar edición
  const abrirEditar = (facultad) => {
    setNuevaFacultad({
      nombre: facultad.nombre,
      valor_nucleo: facultad.valor_nucleo,
    });
    setFacultadId(facultad.id);
    setEditando(true);
    setMostrarModal(true);
  };

  // Eliminar facultad
  const confirmarEliminar = (id) => {
  setFacultadEliminar(id);
  setMostrarEliminar(true);
};

const eliminarFacultad = async () => {
  try {
    await axios.delete(`/facultades/${facultadEliminar}`);

    mostrarAlerta("Facultad eliminada correctamente");

    setMostrarEliminar(false);
    setFacultadEliminar(null);

    cargarFacultades();
  } catch (error) {
    console.error("Error al eliminar facultad:", error);

    mostrarAlerta(
      error.response?.data?.message || "Error al eliminar la facultad",
      "danger"
    );

    setMostrarEliminar(false);
  }
};

  return (
    <div className="container-fluid bg-light min-vh-100 py-4 px-3 px-md-4 px-lg-5">
      {alerta.mostrar && (
        <div
          className={`alert alert-${alerta.tipo} alert-dismissible fade show shadow position-fixed`}
          style={{ top: "20px", right: "20px", zIndex: 9999, minWidth: "300px" }}
        >
          <div className="d-flex align-items-center">
            <i
              className={`bi me-2 ${
                alerta.tipo === "success" ? "bi-check-circle-fill" : "bi-x-circle-fill"
              }`}
            ></i>
            <span>{alerta.mensaje}</span>
          </div>
          <button
            className="btn-close"
            onClick={() => setAlerta({ ...alerta, mostrar: false })}
          ></button>
        </div>
      )}

      {/* Header */}
      <div className="card shadow-sm border-0 mb-4 border-start border-primary border-4 rounded-3">
        <div className="card-body d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-outline-primary border-0 rounded-circle p-2"
              onClick={() => navigate("/DashboardSecretaria")}
              title="Volver al dashboard"
            >
              <i className="bi bi-arrow-left-short fs-4"></i>
            </button>
            <h4 className="fw-bold mb-0 text-dark">
              <i className="bi bi-building me-2 text-primary"></i>
              Gestión de Facultades
            </h4>
          </div>

          <button
            className="btn btn-primary d-flex align-items-center gap-2 shadow-sm px-3"
            onClick={() => {
              setEditando(false);
              setNuevaFacultad({ nombre: "", valor_nucleo: "" });
              setMostrarModal(true);
            }}
          >
            <i className="bi bi-plus-lg"></i>
            Nueva Facultad
          </button>
        </div>
      </div>

      {/* Tabla */}
      <div className="card shadow-sm border-0 rounded-3 overflow-hidden">
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light text-uppercase small text-muted">
                  <tr>
                    <th className="ps-4 border-0">Nombre</th>
                    <th className="border-0">Valor Núcleo ($)</th>
                    <th className="text-end pe-4 border-0">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {facultades.length === 0 ? (
                    <tr>
                      <td colSpan={3} className="text-center py-5 text-muted">
                        <i className="bi bi-building fs-1 d-block mb-3 text-primary opacity-50"></i>
                        No hay facultades registradas aún
                      </td>
                    </tr>
                  ) : (
                    facultades.map((f) => (
                      <tr key={f.id}>
                        <td className="ps-4 fw-medium">{f.nombre}</td>
                        <td className="fw-semibold">
                          ${parseFloat(f.valor_nucleo).toLocaleString("es-CL")}
                        </td>
                        <td className="text-end pe-4">
                          <button
                            className="btn btn-sm btn-outline-primary me-2"
                            onClick={() => abrirEditar(f)}
                            title="Editar facultad"
                          >
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => confirmarEliminar(f.id)}
                            title="Eliminar facultad"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal CREAR / EDITAR */}
      {mostrarModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.55)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content rounded-4 shadow border-0">
              <div className="modal-header border-0 pb-0">
                <h5 className="modal-title fw-bold text-primary">
                  {editando ? "Editar Facultad" : "Nueva Facultad"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setMostrarModal(false)}
                ></button>
              </div>

              <div className="modal-body px-4 pb-4">
                <div className="mb-3">
                  <label className="form-label fw-medium">Nombre de la Facultad</label>
                  <input
                    className="form-control"
                    placeholder="Ej: Facultad de Ingeniería"
                    name="nombre"
                    value={nuevaFacultad.nombre}
                    onChange={handleChange}
                    autoFocus
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-medium">Valor Núcleo ($)</label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    placeholder="0.00"
                    name="valor_nucleo"
                    value={nuevaFacultad.valor_nucleo}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="modal-footer border-0 px-4 pb-4">
                <button
                  className="btn btn-outline-secondary px-4"
                  onClick={() => setMostrarModal(false)}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-primary px-4 d-flex align-items-center gap-2"
                  onClick={guardarFacultad}
                >
                  <i className="bi bi-check-lg"></i>
                  {editando ? "Actualizar" : "Guardar"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {mostrarEliminar && (
  <div
    className="modal fade show d-block"
    style={{ backgroundColor: "rgba(0,0,0,.55)" }}
  >
    <div className="modal-dialog modal-dialog-centered">
      <div
        className="modal-content border-0 shadow-lg rounded-4"
        style={{ overflow: "hidden" }}
      >
        {/* Cabecera */}
        <div
          className="text-center py-4"
          style={{ background: "#dc3545" }}
        >
          <div
            className="bg-white rounded-circle mx-auto d-flex align-items-center justify-content-center"
            style={{
              width: "75px",
              height: "75px",
            }}
          >
            <i
              className="bi bi-trash-fill text-danger"
              style={{ fontSize: "34px" }}
            ></i>
          </div>
        </div>

        {/* Contenido */}
        <div className="modal-body text-center px-4 py-4">
          <h4 className="fw-bold mb-3">
            ¿Eliminar facultad?
          </h4>

          <p className="text-muted mb-0">
            Esta acción eliminará permanentemente la facultad seleccionada.
            <br />
            <strong>Esta acción no se puede deshacer.</strong>
          </p>
        </div>

        {/* Botones */}
        <div className="modal-footer border-0 justify-content-center pb-4">
          <button
            className="btn btn-light border px-4"
            onClick={() => {
              setMostrarEliminar(false);
              setFacultadEliminar(null);
            }}
          >
            Cancelar
          </button>

          <button
            className="btn btn-danger px-4 d-flex align-items-center gap-2"
            onClick={eliminarFacultad}
          >
            <i className="bi bi-trash-fill"></i>
            Sí, eliminar
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default AdminFacultades;